import React from 'react'
import { Stack, Typography } from '@mui/material'
import { K1Information } from '@e3dc-react/icons'
import { makeStyles } from 'tss-react/mui'

interface Props {
  message: string
  containerClassName?: string
  iconColor?: string
}

const useStyles = makeStyles()(theme => ({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: theme.spacing(2),
    padding: theme.spacing(2),
    width: '100%',

    borderColor: theme.palette.shades.shade03,
    backgroundColor: theme.palette.shades.shade04,
    borderRadius: theme.spacing(2),
  },
}))

/**
 * Component to display a information
 */
const InformationTile: React.FC<Props> = ({ message, containerClassName, iconColor }) => {
  const { classes, cx } = useStyles()
  return (
    <Stack className={cx(classes.container, containerClassName)}>
      <K1Information sx={{ color: iconColor }} />
      <Typography variant="caption">{message}</Typography>
    </Stack>
  )
}

export default InformationTile
